import { events } from "@/common/constants";
import emitter from "../emitter";

import { useAssetsStore } from "@/mono/store/assets";

export default class Workers {
  static offscreenCanvas = null;

  static init() {
    this.loader = new Worker(new URL("./LoadWorker.js", import.meta.url), {
      type: "module",
    });

    this.loader.onmessage = (event) => {
      if (event.data.type === "loading:progress") {
        useAssetsStore.getState().addAsset(event.data.data.asset);
      }
    };

    const loadStart = (assetList) => {
      this.loader?.postMessage({ type: "loading:start", data: assetList });
    };

    emitter.on(events.LOADING_START, loadStart);

    emitter.on(events.LOADING_COMPLETE, () => {
      this.loader?.terminate();
      this.loader = null;
    });
  }

  static setOffScreenCanvas(worker) {
    this.offscreenCanvas = worker;
  }

  static dispose() {
    this.loader?.terminate();
    this.loader = null;

    this.offscreenCanvas?.terminate();
    this.offscreenCanvas = null;
  }

  static animateGLBackgroundIn() {
    this.offscreenCanvas?.postMessage({ type: "animateGLBackgroundIn" });

    return new Promise((resolve) => {
      this.offscreenCanvas.onmessage = (event) => {
        if (event.data.type === "animateGLBackgroundInComplete") {
          emitter.emit(events.ANIMATE_GL_BACKGROUND_IN_COMPLETE);
          resolve();
        }
      };
    });
  }

  static animateGLBackgroundOut() {
    this.offscreenCanvas?.postMessage({ type: "animateGLBackgroundOut" });

    return new Promise((resolve) => {
      this.offscreenCanvas.onmessage = (event) => {
        if (event.data.type === "animateGLBackgroundOutComplete") {
          emitter.emit(events.MENU_OUT_COMPLETE);
          resolve();
        }
      };
    });
  }

  static setGLBackgroundTheme(theme) {
    this.offscreenCanvas?.postMessage({
      type: "setGLBackgroundTheme",
      data: theme,
    });
  }
}
